import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.manage-user.move-shared-accounts', {
        url: '/move-shared-accounts',
        params: {accounts: []},
        component: 'companyUserDirectoriesManageUserMoveSharedAccounts',
        resolve: {
            accounts,
        },
    });
}

/** @ngInject */
function accounts($stateParams) {
    return $stateParams.accounts;
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-user/move-shared-accounts/move-shared-accounts.state.js